export default {
    methods: {
        trackFormEvent({ eventType, step = null, pc_id = null, pc_guid = null }) {
            fetch('/complaint_form/track', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
                },
                body: JSON.stringify({
                    event_type: eventType,
                    step: step,
                    pc_id: pc_id,
                    pc_guid: pc_guid,
                    client_language: navigator.language,
                })
            }).catch((e) => {
                console.warn('Tracking error:', e)
            })
        },
        trackStepPassedFormEvent(step) {
            this.trackFormEvent({
                eventType: 'step_passed',
                step: step,
                pc_guid: new URLSearchParams(window.location.search).get('pc_guid'),
            })
        },
    }
}
